export default class EnvConfig {
    front_api = import.meta.env.VITE_FRONT_API;
}